import React, { useCallback, useContext, useState } from 'react';
import Router from 'next/router';
import IconText from '../common/IconText';
import DivButton from '../a11y/DivButton';
import H from '../elements/H';
import HyperLink from '../elements/HyperLink';
import { NavigationHistoryContext } from './NavigationHistoryTracker';
import RouteLink from './RouteLink';

interface BackButtonProps {
  defaultTitle: string;
  defaultPath: string;
}

const BackButton: React.FunctionComponent<BackButtonProps> = ({
  defaultTitle,
  defaultPath
}) => {
  const navigationHistory = useContext(NavigationHistoryContext);
  const [forceHover, setForceHover] = useState(false);
  const backItem = navigationHistory.getBackItem();
  const title = backItem ? '' : defaultTitle;
  const label = (
    <IconText
      icon="nav-arrow-left"
      iconSize={[4, 5, 5]}
      iconHoverColor="purple-light"
      iconForceHover={forceHover}
    >
      <H styling="h4" tag="div">
        <strong>{title}</strong>
      </H>
    </IconText>
  );
  const backOnClick = useCallback(() => Router.back(), []);
  return (
    <div className="back-button">
      {backItem ? (
        <DivButton
          onClick={backOnClick}
          data-testid="history-back-button"
          data-cy="back-button-history"
        >
          {label}
        </DivButton>
      ) : (
        <div
          onMouseOver={() => {
            return setForceHover(true);
          }}
          onFocus={() => {
            return setForceHover(true);
          }}
          onMouseLeave={() => {
            return setForceHover(false);
          }}
          data-cy="default-back-button"
        >
          <RouteLink path={defaultPath}>
            <HyperLink noLinkStateStyles data-testid="default-back-button">
              {label}
            </HyperLink>
          </RouteLink>
        </div>
      )}
    </div>
  );
};

export default BackButton;
